@use '~/theme/theme' as *;

.root,
.searchResults {
  display: flex;
  flex-direction: column;
}

.searchResults {
  flex-grow: 1;
  flex-shrink: 1;
  gap: spacing(2);
  overflow-y: auto;
}

.root {
  gap: spacing(4);
}

.searchRow {
  display: flex;
  gap: spacing(8);
  align-items: start;
}
